/**
 * The first line of an idea's notes, as plain text, for a one-line preview.
 *
 * Notes are markdown, so the markers go: a heading's `#`, a list's bullet or
 * number, a quote's `>`, emphasis, inline code and a link's URL. Fences and
 * rules are skipped, since neither says anything on its own.
 */
export function firstLineOf(body: string): string {
  let fenced = false
  for (const raw of body.replace(/\r\n?/g, '\n').split('\n')) {
    if (/^\s*```/.test(raw)) {
      fenced = !fenced
      continue
    }
    const line = fenced ? raw.trim() : plain(raw)
    if (line && !/^([-*_])(\s*\1){2,}$/.test(line)) return line
  }
  return ''
}

function plain(line: string): string {
  return line
    .replace(/^\s*(?:#{1,6}\s+|>\s?|[-*+]\s+|\d+[.)]\s+)+/, '')
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/(\*\*|__)(.+?)\1/g, '$2')
    .replace(/(^|[^\w*])[*_](?!\s)(.+?)(?<!\s)[*_](?=[^\w*]|$)/g, '$1$2')
    .replace(/`([^`]*)`/g, '$1')
    .replace(/\s+/g, ' ')
    .trim()
}
